
import React from 'react';
import { Box } from 'grommet';

import VyhodnoceniValueMeterTile from './VyhodnoceniValueMeterTile';

const VYHODNOCENI_DEFINITIONS = [
    {
        title: 'Intenzita produkce',
        valueName: 'vinice_podil',
        infoTexts: [
            {title: 'Trať', valueName: 'vymera'},
            {title: 'Vinice', valueName: 'vinice_vymera'}
        ]
    },
    {
        title: 'Podíl černého úhoru',
        valueName: 'cerny_uhor_podil',
        infoTexts: [
            {title: 'Vinice', valueName: 'vinice_vymera'},
            {title: 'Černý úhor', valueName: 'cerny_uhor_vymera'}
        ]
    },
    {
        title: 'Podíl ozeleněných vinic',
        valueName: 'ozeleneni_podil',
        infoTexts: [
            {title: 'Vinice', valueName: 'vinice_vymera'},
            {title: 'Ozelenění všech řádků', valueName: 'ozeleneni_vse_vymera'},
            {title: 'Ozelenění každého 2.řádku', valueName: 'ozeleneni_druhy_vymera'},
        ]
    },
    {
        title: 'Podíl mimoprodukční vegetace v trati',
        valueName: 'neprodukcni_podil',
        infoTexts: [
            {title: 'Trať', valueName: 'vymera'},
            {title: 'Mimoprodukční vegetace', valueName: 'neprodukcni_vymera'}
        ]
    }
];

const VyhodnoceniValueMeters = ({tratVyhodnoceni}) => {
    return (
        <Box direction="row" justify="center" wrap={true}>
            {VYHODNOCENI_DEFINITIONS.map(item => {
                return (
                    <VyhodnoceniValueMeterTile
                        key={item.valueName}
                        tratVyhodnoceni={tratVyhodnoceni}
                        definition={item}
                    />
                );
            })}
        </Box>
    );
}

export default VyhodnoceniValueMeters;
